import { useState } from 'react';
import { useGetDocuments } from '../../api/useGetDocuments';
import type { DocumentFilters } from '../../api/keys';
import { DOCUMENTS_PAGE_SIZE_OPTIONS } from '../../constants/pagination';

type Props = {
  filters: DocumentFilters;
};

export default function useDocumentList(props: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DOCUMENTS_PAGE_SIZE_OPTIONS[0]);
  const { data, isLoading, isError } = useGetDocuments(props.filters, page, rowsPerPage);

  const count = data?.count ?? 0;

  function handleRowsPerPageChange(value: number) {
    setRowsPerPage(value);
    setPage(0);
  }

  return {
    documents: data?.data ?? [],
    count,
    isLoading,
    isError,
    isEmpty: !isLoading && !isError && count === 0,
    // A single short page needs no pagination controls.
    showPagination: count > DOCUMENTS_PAGE_SIZE_OPTIONS[0],
    page,
    rowsPerPage,
    handlePageChange: setPage,
    handleRowsPerPageChange,
  };
}
